import { render } from "./ReportesFiltros_pdf.vue?vue&type=template&id=6fb7d19d&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ReportesFiltros_pdf.vue?vue&type=script&lang=js"
export * from "./ReportesFiltros_pdf.vue?vue&type=script&lang=js"

import "./ReportesFiltros_pdf.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script